window.lightGallery = require ('lightgallery/lightgallery.umd');
window.lgThumbnail = require("lightgallery/plugins/thumbnail/lg-thumbnail.umd");
// window.lgZoom = require("lightgallery/plugins/zoom/lg-zoom.umd");
// window.lgShare = require("lightgallery/plugins/share/lg-share.umd");
// window.lgFullscreen = require("lightgallery/plugins/fullscreen/lg-fullscreen.umd");

// require ('lg-thumbnail');
// require ('lg-hash');
// // require ('lg-autoplay');
// require('jquery-mousewheel');

let galleries = document.getElementsByClassName('lightgallery')
for (let i=0; i<galleries.length; i++) {
    lightGallery(galleries[i], {
        plugins: [lgThumbnail],
        // plugins: [lgZoom, lgThumbnail, lgShare, lgFullscreen],
        customSlideName: true,
        selector: ".image:not(.slick-cloned)",
        allowMediaOverlap: true,
        thumbnail: true,
        animateThumb: true,
        toggleThumb: true,
        mousewheel: true,
        hash: true,
        galleryId: i,
        showThumbByDefault: true,
        // autoplay: false,
        // autoplayControls: false,
        // fullScreen: false,
        // mode: "lg-fade",
        // zoom: false,
        // share: false,
        // mobileSettings: {
        //     controls: false,
        //     showCloseIcon: false,
        //     download: false,
        //     rotate: false
        // }
    })
}

$('.lg_link').on('click', function() {
    $(this).next('.lightgallery').find('.image:first-of-type > img').trigger("click")
})

// $(".lightgallery").lightGallery({
//     autoplay: false,
//     autoplayControls: false,
//     thumbnail: true,
//     selector: ".image:not(.slick-cloned)",
//     fullScreen: false,
//     animateThumb: false,
//     showThumbByDefault: false,
//     mode: "lg-fade",
//     hash: true,
//     zoom: false,
//     share: false,
//     cssEasing: "cubic-bezier(.25, 0, .25, 1)"
// })